import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

const TaskDetailAssignee = styled.div`
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  position: relative;
`;

export const Wrapper = styled.div<{
  size: number | string;
  bgColor: string | null;
  backgroundURL: string | null;
  hasClick: boolean;
}>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(${props => (props.backgroundURL ? props.theme.colors.text.primary : '0,0,0')});
  background: ${props => (props.backgroundURL ? `url(${props.backgroundURL})` : props.bgColor)};
  background-position: center;
  background-size: contain;
  font-size: 14px;
  font-weight: 400;
  ${props =>
    props.hasClick &&
    css`
      &:hover {
        opacity: 0.8;
      }
    `}
`;

type TaskAssigneeProps = {
  size: number | string;
  member: {
    id: string;
    profileIcon?: ProfileIcon;
  };
  onMemberProfile?: ($targetRef: React.RefObject<HTMLElement>, memberID: string) => void;
  className?: string;
};

const TaskAssignee: React.FC<TaskAssigneeProps> = ({ member, onMemberProfile, size, className }) => {
  const $memberRef = useRef<HTMLDivElement>(null);
  let profileIcon: ProfileIcon = {
    url: null,
    bgColor: null,
    initials: null,
  };
  if (member.profileIcon) {
    profileIcon = member.profileIcon;
  }
  return (
    <TaskDetailAssignee
      className={className}
      ref={$memberRef}
      onClick={e => {
        e.stopPropagation();
        if (onMemberProfile) {
          onMemberProfile($memberRef, member.id);
        }
      }}
      key={member.id}
    >
      <Wrapper
        hasClick={typeof onMemberProfile !== undefined}
        backgroundURL={profileIcon.url ?? null}
        bgColor={profileIcon.bgColor ?? null}
        size={size}
      >
        {(!profileIcon.url && profileIcon.initials) ?? ''}
      </Wrapper>
    </TaskDetailAssignee>
  );
};

export default TaskAssignee;
